import { JSX } from "react";
import { useTranslation } from "react-i18next";

import Button from "@/components/buttons/Button.tsx";
import { MODAL_ROUTES } from "@/components/modals/router/ModalRoutes";

import { useDeleteAccountSendCode } from "@/hooks/api/user.hooks";
import useModalRouter from "@/hooks/useModalRouter";
import { onError } from "@/utils/onError";
import { onSuccess } from "@/utils/onSuccess";

const DeleteAccountModal = (): JSX.Element => {
  const { t } = useTranslation();

  const { openModal, closeModal } = useModalRouter();

  const { mutate, isPending } = useDeleteAccountSendCode();
  const handleDelete = () => {
    mutate(undefined, {
      onSuccess() {
        openModal(MODAL_ROUTES.DELETE_ACCOUNT_CODE);
        onSuccess(t("account.sent-code"));
      },
      onError,
    });
  };

  return (
    <div className="max-w-[32.5rem]">
      <div className={"staff-modal__header mb-6"}>
        <h2 className={"staff-modal__title"}>{t("account.delete-account")}</h2>
        <p className={"staff-modal__description"}>{t("account.delete-account-message")}</p>
      </div>
      <div className="flex flex-row gap-6">
        <Button title={t("Actions.cancel")} color={"black"} onClick={closeModal}>
          {t("Actions.cancel")}
        </Button>
        <Button title={t("Actions.delete")} onClick={handleDelete} isLoading={isPending}>
          {t("Actions.delete")}
        </Button>
      </div>
    </div>
  );
};

export default DeleteAccountModal;
